import {useTooltipContext} from '../hooks/useTooltipContext'
import {MercatorMapFeature} from './MercatorMap'

export const useMercatorChartTooltipContext = () => {
  return useTooltipContext<MercatorMapFeature | undefined>()
}
